import { Link } from 'react-router-dom'
import './SiteFooter.css'

const APP_STORE_URL = 'https://apps.apple.com/us/app/contrast-shower/id6766412214'
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.contrastshower'

export default function SiteFooter() {
  return (
    <>
      {/* ── Download / Get the App CTA — matches index "download" section ── */}
      <section className="section-landing-download">
        <div className="section-download-container">
          <h2 className="eyebrow download-eyebrow">Over 50,000 daily contrast showers tracked</h2>
          <h2 className="heading-light">Take the Plunge</h2>
          <p className="download-copy">
            Download Contrast Shower and experience the benefits of contrast hydrotherapy for yourself.
          </p>
          <div className="section-download-buttons">
            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="app-store-button w-button"></a>
            <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" className="play-store-button w-button"></a>
          </div>
          <div className="download-hero-section">
            <div aria-hidden="true" className="stroke-coral ghost-text-download">Contrast<br />Shower</div>
            <img
              src="/images/download-hero-landscape_11.20_opt.png"
              width={848}
              alt="App download"
              className="section-download-hero"
            />
            <img
              src="/images/download-hero-portrait.png"
              width={200}
              height={516}
              alt=""
              className="section-download-mobile-hero"
            />
          </div>
        </div>
      </section>

      {/* ── Footer — matches index "footer" section exactly ──────────── */}
      <footer className="section-footer">
        <div className="section-footer-container">
          <div>
            <div className="section-footer-social">
              <h2 className="stroke-charcoal ghost-text-footer">Connect</h2>
              <a href="#" target="_blank" rel="noopener noreferrer" className="section-footer-social-button social-button-instagram w-button">Instagram</a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="section-footer-social-button social-button-twitter w-button">Twitter</a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="section-footer-social-button social-button-facebook w-button">Facebook</a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="section-footer-social-button social-button-youtube w-button">YouTube</a>
              <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="section-footer-social-button social-button-ios w-button">App Store</a>
              <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" className="section-footer-social-button social-button-google w-button">Google Play</a>
            </div>
            <h2 className="stroke-charcoal ghost-text-footer">Explore</h2>
            <div className="section-footer-nav-links">
              <div className="section-footer-nav-sections">
                <h4 className="section-footer-label">App</h4>
                <a href="#" className="section-footer-link w-inline-block"><div className="text-block-2">Premium</div></a>
                <a href="/#why" className="section-footer-link w-inline-block"><div className="text-block-2">Why Contrast?</div></a>
                <Link to="/articles" className="section-footer-link w-inline-block"><div className="text-block-2">Blog</div></Link>
              </div>
              <div className="section-footer-nav-sections">
                <h4 className="section-footer-label">More Info</h4>
                <Link to="/contact-us" className="section-footer-link w-inline-block"><div className="text-block-2">Contact Us</div></Link>
                <a href="#" className="section-footer-link w-inline-block"><div className="text-block-2">FAQs</div></a>
                <Link to="/privacy-policy" className="section-footer-link w-inline-block"><div className="text-block-2">Privacy Policy</div></Link>
                <Link to="/terms-and-conditions" className="section-footer-link w-inline-block"><div className="text-block-2">Terms and Conditions</div></Link>
              </div>
            </div>
          </div>
          <div className="section-footer-legal">
            <div>© {new Date().getFullYear()} Contrast Shower. All Rights Reserved</div>
          </div>
        </div>
      </footer>
    </>
  )
}
